// extracted by mini-css-extract-plugin
export default {"container":"wgY9ER9A","backButtonContainer":"AXD6qb0I","backButton":"TGATe08X"};